var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMimosysUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.132,
    height: 26.757,
    viewBox: "0 0 29.132 26.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-left",
    "data-name": "Icon awesome-arrow-left",
    d: "M10.147,18.706l-.875.875a.942.942,0,0,1-1.336,0L.274,11.923a.942.942,0,0,1,0-1.336L7.936,2.925a.942.942,0,0,1,1.336,0l.875.875a.947.947,0,0,1-.016,1.352L5.382,9.677l17.369.039a.944.944,0,0,1,.946.946v1.261a.944.944,0,0,1-.946.946L5.382,12.83l4.749,4.525A.94.94,0,0,1,10.147,18.706Z",
    transform: "translate(30.452 17.2) rotate(150)",
    fill: "#f77777"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMimosysUp);
export default __webpack_public_path__ + "static/media/ico-mimosys-up.b19e6b3a19de80cee563e5fa91c51a19.svg";
export { ForwardRef as ReactComponent };